import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Box, Flex, Button, Copy, Icon } from '@elparking/components'
import Resume from '../Resume'
import { BottomBarWrapper } from '../../ui/BottomBar'

const CurrencyWrapperLarge = ({ children }) =>
    <Copy as='span' padding='0' fontSize='large'>
        {children}
    </Copy>

CurrencyWrapperLarge.propTypes = {
    children: PropTypes.node,
}

function BottomBar ({ booking, onNext, disabled, setOnCloseModal, continueText }) {
    const [isExpanded, setIsExpanded] = useState(false)

    const toggleExpanded = () => {
        setIsExpanded((prevIsExpanded) => !prevIsExpanded)
    }

    useEffect(() => {
        setOnCloseModal(isExpanded
            ? () => setIsExpanded(false)
            : null)
    }, [ isExpanded, setIsExpanded, setOnCloseModal ])

    return (
        <BottomBarWrapper expanded={isExpanded} dataTest='booking-process-bottom-bar'>
            {isExpanded
                ? <Box width='100%'>
                    <Box textAlign='right' padding='1em 1em 0 1em' onClick={toggleExpanded}>
                        <Icon type='x' size='xxLarge' color='gray'/>
                    </Box>
                    <Box p='1em'>
                        <Resume />
                    </Box>
                </Box>
                : <Box p='5px 1em 0 1em'>
                    <Flex width='100%' alignItems='center'>
                        <Box flex='1 0 auto' onClick={toggleExpanded}>
                            <Copy fontSize='large' fontWeight='medium' fontColor='gray'>
                                <CurrencyWrapperLarge>{booking.rate.displayPrice}</CurrencyWrapperLarge>
                            </Copy>
                            <Copy padding='8px 0 0 0' dataTest='expand-button' fontSize='xxSmall' fontWeight='medium' fontColor='main' uppercased>
                                <FormattedMessage defaultMessage='Ver más detalle' />
                            </Copy>
                        </Box>
                        <Box flex='2 0 auto'>
                            <Button height='auto' disabled={disabled} type={onNext ? 'button' : 'submit'} onClick={onNext} dataTest='continue-button' fontWeight='bold' width='100%'>
                                { continueText || <FormattedMessage defaultMessage='Continuar' />}
                            </Button>
                        </Box>
                    </Flex>
                </Box>
            }
        </BottomBarWrapper>
    )
}

BottomBar.propTypes = {
    onNext: PropTypes.func,
    setOnCloseModal: PropTypes.func,
    disabled: PropTypes.bool,
    booking: PropTypes.object,
    continueText: PropTypes.node,
}

BottomBar.defaultProps = {
    setOnCloseModal: () => {},
    disabled: false,
}

export default BottomBar
